import React from "react";

const DateDisplay = ({ format, value }) => {
    if (typeof value === "string") value = new Date(value);

    let displayDate = format
        .replace("0D", String(value.getDate()).padStart(2, "0"))
        .replace("DD", String(value.getDate()))
        .replace("0M", String(value.getMonth() + 1).padStart(2, "0"))
        .replace("MM", String(value.getMonth() + 1))
        .replace("YYYY", value.getFullYear());

    return <span className="display-date">{displayDate}</span>;
};

export default DateDisplay;



// WEBPACK FOOTER //
// ./src/components/Date.js